import React from "react";

// Catches unexpected render errors. Details go to the console only; users see a generic message.
export default class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled UI error:", error, info?.componentStack);
    window.posthog?.captureException?.(error);
  }

  componentDidUpdate(prevProps) {
    // Recover automatically when the route changes.
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="container-x py-24 text-center" role="alert" data-testid="error-fallback">
        <h1 className="font-serif text-4xl md:text-5xl">Something went wrong</h1>
        <p className="text-black/60 mt-4 max-w-md mx-auto">
          An unexpected error occurred. You can try again or head back to the homepage.
        </p>
        <div className="flex gap-3 justify-center mt-8">
          <button className="btn-filled" onClick={() => this.setState({ hasError: false })}>Try again</button>
          <a href="/" className="btn-outline inline-block">Go to homepage</a>
        </div>
      </div>
    );
  }
}
